import { Button, TextField, InputAdornment, styled, Box, Checkbox, FormControlLabel } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import SearchIcon from '@mui/icons-material/Search'
import { useEffect, useState } from 'react'
import { SPACING } from '@common/theme/spacing'

interface SubjectsTimepointsTableToolbarProps {
  onSearch: (value: string) => void
  searchValue?: string
  onAddClick: () => void
  submittedOnly?: boolean
  submittedOnlyLocked?: boolean
  onSubmittedOnlyChange?: (submittedOnly: boolean) => void
}

const ToolbarContainer = styled(Box)({
  padding: 16,
  display: 'flex',
  gap: 24,
  alignItems: 'center',
})

export default function SubjectsTimepointsTableToolbar({
  onSearch,
  searchValue,
  onAddClick,
  submittedOnly = false,
  submittedOnlyLocked = false,
  onSubmittedOnlyChange,
}: Readonly<SubjectsTimepointsTableToolbarProps>) {
  const [localSearchValue, setLocalSearchValue] = useState(searchValue ?? '')
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLocalSearchValue(event.target.value)
  }
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      onSearch(localSearchValue)
    }
  }

  useEffect(() => {
    setLocalSearchValue(searchValue ?? '')
  }, [searchValue])

  const handleAddClick = () => {
    onAddClick()
  }

  return (
    <ToolbarContainer
      sx={{ paddingX: 0, display: 'flex', justifyContent: 'flex-end', gap: SPACING.tableToolbarItemsSpacing }}
    >
      {onSubmittedOnlyChange ? (
        <FormControlLabel
          control={
            <Checkbox
              checked={submittedOnlyLocked || submittedOnly}
              disabled={submittedOnlyLocked}
              onChange={(_event, checked) => onSubmittedOnlyChange(checked)}
            />
          }
          label="Submitted visits only"
        />
      ) : null}
      <Button variant="contained" color="secondary" startIcon={<AddIcon />} size="small" onClick={handleAddClick}>
        Add Subject
      </Button>
      <TextField
        name="search"
        id="search"
        placeholder="Search"
        variant="outlined"
        size="small"
        sx={{ minWidth: 300 }}
        value={localSearchValue}
        onChange={handleSearchChange}
        onKeyDown={handleKeyDown}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          },
        }}
      />
    </ToolbarContainer>
  )
}
